import { AnalyticsStore } from 'bernie-core';

import { trackCountsFormAnalytics, trackAnalytics } from 'utility';
import { FlightsTravelerType } from '__generated__/api';
import { FlightsSearchFormTravelersOption } from 'types/search/wizard';
import { AnalyticsType } from 'types/shared';

export const getAgeOptionsDataTestId = (labelTemplate: string, labelToken: string, itr: number): string => {
  const dataTestId = `${labelTemplate}select-${itr}`;

  return dataTestId.replace(labelToken, '').replace(/ /g, '-').toLowerCase();
};

export const getInfantOptionsDataTestId = (itemType: FlightsTravelerType): string => {
  return itemType.replace(/_/g, '-').toLowerCase();
};

export const INFANT_AGE_LIMIT = 1;

const getSelectedAnalyticsByType = (type: string, travelerOptions: FlightsSearchFormTravelersOption) => {
  const { ADULT, CHILD, INFANT_IN_LAP, INFANT_IN_SEAT } = FlightsTravelerType;
  const { adultSelectedAnalytics, childrenSelectedAnalytics, infantSelectedAnalytics } = travelerOptions;

  switch (type) {
    case ADULT:
      return adultSelectedAnalytics;
    case CHILD:
      return childrenSelectedAnalytics;
    case INFANT_IN_LAP:
    case INFANT_IN_SEAT:
      return infantSelectedAnalytics;
  }
};

const getTrackableAnalytics = (type: string, travelerOptions: FlightsSearchFormTravelersOption) => {
  const { INFANT_IN_LAP, INFANT_IN_SEAT } = FlightsTravelerType;
  const { infantLapAnalytics, infantSeatAnalytics } = travelerOptions;

  switch (type) {
    case INFANT_IN_LAP:
      return infantLapAnalytics;
    case INFANT_IN_SEAT:
      return infantSeatAnalytics;
  }
};

const trackCountsFormAnalyticsWrapper = (
  analytics: AnalyticsStore,
  selectedAnalytics: AnalyticsType,
  travelerCount: number,
  trackableAnalytics: AnalyticsType
) => {
  trackCountsFormAnalytics(analytics, selectedAnalytics, travelerCount);
  if (trackableAnalytics) {
    trackAnalytics(trackableAnalytics, analytics);
  }
};

export const trackTravelersOptions = (travelerOptions: FlightsSearchFormTravelersOption, analytics: AnalyticsStore) => {
  travelerOptions.items.map(travelerOptionItem => {
    const { type, travelerCount } = travelerOptionItem;
    const selectedAnalytics = getSelectedAnalyticsByType(type, travelerOptions);
    const trackableAnalytics = travelerCount > 0 ? getTrackableAnalytics(type, travelerOptions) : null;
    trackCountsFormAnalyticsWrapper(analytics, selectedAnalytics, travelerCount, trackableAnalytics);
  });
};
